export const INVENTORY_ROUTE_NAMES = {
  ACTIVE_PRODUCTS: 'active-products',
  BATCH_MANAGEMENT: 'batch-management',
  INVENTORY_OVERVIEW: 'inventory-overview',
  LISTINGS: 'listings',
  LISTINGS_NEW: 'listings-new',
  PACKAGING_LIST: 'packaging-list',
  PRODUCT_AUDIT_LOG: 'product-audit-log',
  PRODUCT_EDIT: 'product-edit',
  PRODUCT_CLONE: 'product-clone',
  PRODUCT_LINES: 'product-lines',
  PRODUCT_REVIEW: 'product-review',
  PRODUCT_TEMPLATES: 'product-templates',
  PRODUCTS: 'products',
  PRODUCTS_ADD: 'products-add',
  PRODUCTS_ADD_TEMPLATE: 'products-add-template',
  PRODUCTS_ADD_BULK: 'products-add-bulk',
  PRODUCTS_ARCHIVED: 'products-archived',
  PRODUCTS_NEW: 'products-new',
  PRODUCTS_V2: 'products-v2',
  PRODUCTS_V2_ADD: 'products-v2-add',
  PRODUCTS_V2_CLONE: 'products-v2-clone',
  PRODUCTS_V2_EDIT: 'products-v2-edit',
  PRODUCTS_V2_ADD_TEMPLATE: 'products-v2-add-template',
  QUESTIONS_ANSWERS: 'questions-answers',
  RECONCILE_INVENTORY: 'reconcile',
  STRAINS: 'strains',
};
